import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Link,
} from '@mui/material';
import COLORS from '../../../resources/style/Themes';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

function PermissionsModal(props) {
  const [browser, setBrowser] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('chrome') > -1) {
      setBrowser('Chrome');
    } else if (userAgent.indexOf('firefox') > -1) {
      setBrowser('Firefox');
    } else if (userAgent.indexOf('safari') > -1) {
      if (userAgent.indexOf('chrome') > -1) {
        setBrowser('Chrome');
      } else {
        setBrowser('Safari');
      }
    } else if (
      userAgent.indexOf('edge') > -1 ||
      userAgent.indexOf('edg') > -1
    ) {
      setBrowser('Edge');
    } else {
      setBrowser('Other');
    }
  }, []);

  const renderBrowserLink = () => {
    switch (browser) {
      case 'Chrome':
        return (
          <Link
            href="https://support.google.com/chrome/answer/114662"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(StringKeys.ENABLE_PERIMSSIONS_FOR_BROWSER, {
              browser: `Chrome`,
            })}
          </Link>
        );
      case 'Firefox':
        return (
          <Link
            href="https://support.mozilla.org/en-US/kb/permissions-manager-give-ability-store-passwords-set-cookies-more"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(StringKeys.ENABLE_PERIMSSIONS_FOR_BROWSER, {
              browser: `Firefox`,
            })}
          </Link>
        );
      case 'Safari':
        return (
          <Link
            href="https://developer.apple.com/documentation/safariservices/safari_app_extensions/safari_app_extension_information_property_list_keys/adjusting_website_access_permissions"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(StringKeys.ENABLE_PERIMSSIONS_FOR_BROWSER, {
              browser: `Safari`,
            })}
          </Link>
        );
      case 'Edge':
        return (
          <Link
            href="https://support.microsoft.com/en-us/microsoft-edge/manage-permissions-on-microsoft-edge-5d8fbf77-5f91-40ad-8929-b85beec6c7f5"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(StringKeys.ENABLE_PERIMSSIONS_FOR_BROWSER, { browser: `Edge` })}
          </Link>
        );
      default:
        return t(StringKeys.BROWSER_NOT_DETECTED);
    }
  };

  return (
    <Dialog
      open={props.show}
      onClose={props.onHide}
      aria-labelledby="permissions-modal-title"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        id="permissions-modal-title"
        sx={{ backgroundColor: COLORS.SAFEGUARD_BLUE, color: COLORS.WHITE }}
      >
        {t(StringKeys.ENABLE_PERIMSSIONS)}
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          {t(
            StringKeys.TO_DISPLAY_YOUR_LOCATION_ON_THE_EMERGENCY_MAP_PLEASE_ENABLE_LOCATION_PERISSIONS,
          )}
        </Typography>
        <Typography sx={{ marginTop: 2 }}>{renderBrowserLink()}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={props.onHide}
          color="primary"
          variant="contained"
        >
          {t(StringKeys.CLOSE)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PermissionsModal;
